import { NotificationSettings as NotificationSettingsModule } from '@vedicium/core-vue/build/modules/notifications';

export default class NotificationSettings extends NotificationSettingsModule {
  static uri = `/v2${NotificationSettingsModule.uri}`;

  settings = {
    maintenance: [],
  };
}
